import type { FlutterRequest } from '@/apis/FlutterApiRequests'

export function callFlutterApi(action: FlutterRequest) {
    if (typeof window.flutterChannel !== 'undefined') {
        window.flutterChannel.postMessage(JSON.stringify(action))
    }
}
